'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function Clock(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color;

  return _react2.default.createElement(
    'svg',
    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-clock ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 12 12' },
    _react2.default.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { fill: color, d: 'M12,6 C12,9.313 9.313,12 6,12 C2.687,12 0,9.313 0,6 C0,2.687 2.687,0 6,0 C9.313,0 12,2.687 12,6' }),
      _react2.default.createElement('path', { fill: '#FFF', d: 'M10.75,6 C10.75,8.624 8.624,10.75 6,10.75 C3.376,10.75 1.25,8.624 1.25,6 C1.25,3.376 3.376,1.25 6,1.25 C8.624,1.25 10.75,3.376 10.75,6' }),
      _react2.default.createElement('path', { fill: color, d: 'M5.4434,6.8228 C5.3624,6.7588 5.3224,6.6768 5.3224,6.5808 L5.3224,2.6128 C5.3224,2.5318 5.3504,2.4638 5.4074,2.4068 C5.4644,2.3508 5.5324,2.3228 5.6124,2.3228 L6.3874,2.3228 C6.4674,2.3228 6.5364,2.3508 6.5924,2.4068 C6.6494,2.4638 6.6774,2.5318 6.6774,2.6128 L6.6774,6.0488 L8.2984,7.2098 C8.3624,7.2588 8.3994,7.3228 8.4074,7.4038 C8.4154,7.4838 8.3954,7.5568 8.3464,7.6208 L7.9114,8.2498 C7.8624,8.3148 7.7984,8.3548 7.7174,8.3708 C7.6374,8.3868 7.5644,8.3708 7.5004,8.3228 L5.4434,6.8228 Z' })
    )
  );
}

Clock.propTypes = _bcPropTypes.iconShape;

exports.default = Clock;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/icons/lib/components/Clock/Clock.js
// module id = 156
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14